import {lazy, Suspense} from "react";
import { PageSkeleton } from "../../customs/skeleton/main";


const Main = lazy(() => import("../../components/members/allMembers/main"));

const AllMembers = () => {

    return(

        <Suspense fallback={<PageSkeleton />}>
            <Main/>
        </Suspense>
      
    )
};

export default AllMembers;